import propTypes from 'prop-types';
import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { addRoom } from '../../actions/room';

const AddRoom = ({
    addRoom,
    auth
}) => {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        roomno: '',
        description: '',
        maxcount: '',
        roomtype: '',
        acstatus: false,
        roomrent: '',
        imageurl1: '',
        imageurl2: '',
        imageurl3: ''
    })

    const {
        roomno,
        description,
        maxcount,
        roomtype,
        acstatus,
        roomrent,
        imageurl1,
        imageurl2,
        imageurl3
    } = formData;

    const onChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = (e) => {
        e.preventDefault();
        addRoom(formData, navigate);
    };
  
    return (
        <div className='container' style={{maxWidth: "650px"}}>
        <Card border="warning">
            <Card.Header>Enter Room Information</Card.Header>
            <Card.Body>
                <form style={{ textAlign: "center" }} className="form" onSubmit={ e => onSubmit(e)}>

                    <label>Room Number
                        <input type='text' placeholder='Room Number' name="roomno" value={roomno} required onChange={e => onChange(e)} />
                    </label>
                    
                    <label>AC
                        <select id="acstatus" name="acstatus" value={acstatus} size="1" required onChange={e => onChange(e)}>
                        <option value={false}>No</option>
                        <option value={true}>Yes</option>
                        </select>
                    </label>

                    <label>Max Count
                        <select id="maxcount" name="maxcount" value={maxcount} size="1" required onChange={e => onChange(e)}>
                            <option value={1}>1</option>
                            <option value={2}>2</option>
                            <option value={3}>3</option>
                            <option value={4}>4</option>
                            <option value={5}>5</option>
                            <option value={6}>6</option>
                        </select>
                    </label>

                    <label>Room Type
                        <select id="roomtype" name="roomtype" value={roomtype} size="1" required onChange={e => onChange(e)}>
                            <option value={"Deluxe Double Bed"}>Deluxe Double Bed</option>
                            <option value={"Non-Deluxe Double Bed"}>Non-Deluxe Double Bed</option>
                            <option value={"Suite"}>Suite</option>
                            <option value={"Couple"}>Couple</option>
                            <option value={"Twin Double Bed"}>Twin Double Bed</option>
                            <option value={"Twin Single Bed"}>Twin Singe Bed</option>
                        </select>
                    </label>

                    <label>Room Rent
                        <input type="text" placeholder='Room Rent' name="roomrent" value={roomrent} required onChange={e => onChange(e)} />
                    </label>
                    <br />
                    
                    <label>Image Link 1
                        <input type="text" placeholder='Image Link 1' name="imageurl1" value={imageurl1} onChange={e => onChange(e)} />
                    </label>

                    <label>Image Link 2
                        <input type="text" placeholder='Image Link 2' name="imageurl2" value={imageurl2} onChange={e => onChange(e)} />
                    </label>
                    
                    <label>Image Link 3
                        <input type="text" placeholder='Image Link 3' name="imageurl3" value={imageurl3} onChange={e => onChange(e)} />
                    </label>
                    <br />

                    <label>Description
                        <input type='text' placeholder='Room Description' name="description" value={description} size="150" required onChange={e => onChange(e)} />
                    </label>
                    <br />
                
                    <input type="submit" className="btn btn-success" value="Add Room" /> 
                </form>
            </Card.Body>
        </Card>
        </div>
    )
}

AddRoom.propTypes = {
  addRoom: propTypes.func.isRequired,
  auth: propTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { addRoom })(AddRoom);